<template>
  <router-view />
</template>

<script>

export default {
  name: 'QuotationWrapper'
}
</script>
